import { styled } from '@arpeggi/ui'

export const Row = styled('div', {
  display: 'flex',
  overflow: 'hidden',
  height: '64px',
  borderRadius: 8,
  justifyContent: 'space-between',
  alignItems: 'stretch',
  userSelect: 'none',
  cursor: 'default',
  '& #pause-icon': {
    display: 'none'
  },
  '& #play-icon': {
    display: 'none'
  },
  '&:hover': {
    background: '$blackA025'
  },
  '&:active': {
    background: '$blackA050'
  },
  '&:hover #avatar-overlay': {
    opacity: 1
  },
  '&:hover #pause-icon': {
    display: 'none'
  },
  '&:hover #play-icon': {
    display: 'inline'
  },
  variants: {
    active: {
      true: {
        background: '$blackA025',
        '& #avatar-overlay': {
          opacity: 1
        },
        '& #title': {
          color: '$indigo0700'
        },
        '& #pause-icon, &:hover #pause-icon': {
          display: 'inline'
        },
        '& #play-icon, &:hover #play-icon': {
          display: 'none'
        }
      }
    }
  }
})
